import StudentAnalytics from 'features/analytics/components/StudentAnalytics/StudentAnalytics';
import react from 'react';

const StudentDashboard = () => {

    return (
        <StudentAnalytics />
    )
}

export default StudentDashboard;